import { ThemeEvents } from '@theme/events';

/**
 * Works around a browser quirk that surfaces specifically on the compare page: after the
 * FIRST option change on a given <variant-picker>, VariantPicker#updateVariantPicker
 * (assets/variant-picker.js) morphs in the freshly-fetched markup, but the previously
 * selected radio's `checked` DOM property can be left `true` alongside the newly selected
 * one — even though the correct value is reliably reflected in `data-current-checked`.
 * A radio's `checked` attribute/property permanently decouple the first time it's toggled
 * (the browser's "dirty checkedness flag"), so morph.js's attribute-only reconciliation
 * (copyAttributes) can't clear it — only setting `.checked` directly can. With two radios
 * simultaneously `:checked` in the same fieldset, the theme's sibling-distance CSS that
 * slides the selected "pill" between buttons (variant-main-picker.liquid's --pill-offset
 * rules, which assume exactly one `:checked` per fieldset) miscalculates for every button,
 * painting all of them with the selected fill until the state resolves on a later click.
 *
 * Re-asserts `.checked` from `data-current-checked` right after each update, for every
 * variant-picker on the compare page only (see snippets/compare-variant-picker.liquid).
 */
document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const wrapper = target.closest('.compare-column__variant-picker');
  if (!wrapper) return;

  for (const radio of wrapper.querySelectorAll('input[type="radio"]')) {
    if (!(radio instanceof HTMLInputElement)) continue;
    radio.checked = radio.dataset.currentChecked === 'true';
  }
});
